import ServiceCRUD from '../../../../../services/ServiceCRUDFLEXCHAT';

class ConversationReportService extends ServiceCRUD {
  constructor() {
    super('relatorio');
  }
}

export default new ConversationReportService();
